import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CourseProgressDetailsModalComponent } from './course-progress-details-modal.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@NgModule({
  imports: [
    CommonModule,
    NzSpinModule
  ],
  declarations: [CourseProgressDetailsModalComponent],
  exports: [CourseProgressDetailsModalComponent],
})
export class CourseProgressDetailsModalModule {}
